import {fetchMetrics} from "../helpers";

export const fetchPercentageDifference = (backend, setPercentageDifference) => {
    fetchMetrics(
        ["abQM2ZkxpQxw"],
        (data) => setPercentageDifference(data.data[0][0]),
        backend
    );
};
